import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import MailIcon from '@mui/icons-material/Mail';
import { Alert, Button, InputAdornment, TextField } from "@mui/material";
import { sha1 } from 'crypto-hash';
import { useEffect, useState } from "react";
import '../../assets/css/styles.css';
import ProgressLoading from '../../component/ProgressLoading';
import useAuth from '../../hooks/useAuth';
import { useAppSelector } from "../../redux/hooks";
import { commonData } from "../../redux/slice/commonSlice";
import './login.css';


const Login = () => {
    const { login, error } = useAuth();
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const getLoginData = useAppSelector(commonData);

    useEffect(() => {
        if (getLoginData.isLoading === true) {
            setShowLoading(true);
        } else if (getLoginData.isLoading === false) {
            setShowLoading(false);
        }
    }, [getLoginData.isLoading]);

    const onSubmit = async () => {
        const hashPwd = await sha1(password);
        let payload = {
            UserName: userName,
            Password: hashPwd,
            IpAddress: ''
        }
        await login(payload);
    }

    return (
        <div className="loginBanner" >
            <ProgressLoading showLoading={showLoading} />
            <div className="login-page">
                <div className="loginCard">
                    <div className="loginLogoContainer">
                        <div className="loginLogo"></div>
                    </div>
                    <div className="loginHeader">Chat/Voice Bot Login</div>
                    <div className="loginCaption">Enter your email address and password to access <br />admin portal</div>
                    <div className="loginFormGroup">
                        <TextField
                            id="emailAddress"
                            label="Email Address"
                            onChange={(e) => setUserName(e.target.value)}
                            value={userName}
                            placeholder="hello@armtech.com"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <MailIcon />
                                    </InputAdornment>
                                ),
                            }}
                            variant="filled"
                        />
                        <TextField
                            id="password"
                            label="Password"
                            type={'password'}
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            placeholder="Enter your password"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockOutlinedIcon />
                                    </InputAdornment>
                                ),
                            }}
                            variant="filled"
                        />
                    </div>
                    {error !== null &&
                        <Alert severity="error" sx={{ mb: 3 }}>
                            {error}
                        </Alert>
                    }
                    <Button type="submit" fullWidth
                        variant='contained'
                        disabled={userName === '' || password === ''}
                        onClick={() => onSubmit()}
                    >
                        Sign in
                    </Button>
                </div>
            </div>
        </div>
    )
}
export default Login;